import {pickBy, isEqual} from 'lodash'
import {debug} from 'loglevel'
// import axios from 'axios';
import axios_ from "axios";
import urljoin from "url-join";
import Busboy from "busboy";
import store from "@/store";
import jwt_decode from "jwt-decode";
import { getTokens, setTokens, getIdentity } from "./token.js"

import pdfvuer from "@/components/Pdfvuer";
const {createLoadingTask} = pdfvuer
// const {createLoadingTask, cMapUrl, cMapPacked} = pdfvuer
// debug(createLoadingTask)
// debug(cMapUrl, cMapPacked)
import i18n from '@/i18n'

const axios = axios_.create()
var get_toc_name, get_toc

function qq(q, load_from, batch, opts={})
{
  const {setsn, fields, fromYear, fromMonth, toYear, toMonth, sort} = opts
  const {onDownloadProgress, onDownloadComplete} = opts
  const {access_token} = getTokens()
  const headers = {
    Authorization: "Bearer " + access_token,
  }
  const opt_axios = {onDownloadProgress, headers}
  const url = urljoin("/udpes/api", 'qq')
  const data = {q, load_from, batch, setsn, fields, fromYear, fromMonth, toYear, toMonth, sort}
  // debug('***sort***', sort)
  for(let k in data) {
    if(!data[k]) delete data[k]
  }
  if(onDownloadProgress) onDownloadProgress({loaded: 0, total: 1})
  return axios.post(url, data, opt_axios).then((resp) => {
    return resp.data;
  }).finally(()=>{
    if(onDownloadComplete) onDownloadComplete()
  })
}

function generic_api(endpoint, query={}) {
  const url = urljoin("/udpes/api", endpoint)
  return axios.get(url).then((resp) => {
    return resp.data;
  })
}

function get_journal_vols(uniname) {
  var url = urljoin("/udpes/api/j", String(uniname), "vols")
  return axios.get(url).then((resp) => {
    return resp.data;
  });
}

function get_journal(uniname) {
  var url = urljoin("/udpes/api/journal/", uniname);
  const {access_token} = getTokens()
  const headers = {
    Authorization: "Bearer " + access_token,
  }
  return axios.get(url, {headers}).then((resp) => {
    return resp.data;
  });
}

// function search_journal(uniname, q, load_from, batch) {
//   var url = urljoin("/udpes/api/journal/", uniname, "q", q)
//   if(load_from !== undefined) url = urljoin(url, String(load_from))
//   if(batch !== undefined) url = urljoin(url, String(batch))
//   return axios.get(url).then((resp) => {
//     return resp.data;
//   });
// }

// function search_collection(mainset_id, q, load_from, batch) {
//   var url = urljoin("/udpes/api/c/", mainset_id, "q", q)
//   if(load_from !== undefined) url = urljoin(url, String(load_from))
//   if(batch !== undefined) url = urljoin(url, String(batch))
//   return axios.get(url).then((resp) => {
//     return resp.data;
//   });
// }

// function search_all(q, load_from, batch) {
//   var url = urljoin("/udpes/api/q/", q)
//   if(load_from !== undefined) url = urljoin(url, String(load_from))
//   if(batch !== undefined) url = urljoin(url, String(batch))
//   return axios.get(url).then((resp) => {
//     return resp.data;
//   });
// }

function load_pdf(pdf_data) {
  var p = createLoadingTask({
      // url: '/images/test.pdf',
      data: pdf_data,
      // cMapUrl,
      // cMapPacked,
      // disableFontFace: true,
    })
    .then((pdf) => {
      var page_pps = [];
      for (var i = 0; i < pdf.numPages; i++) {
        const ii = i
        var pp = pdf.getPage(i + 1).then((page) => {
          return page.getTextContent().then((text) => {
            if(text.items.length == 0) {
              return ""
            }
            if(ii == 0) debug('pt text', ii, text)
            var last_transform = text.items[0].transform.slice(0, 4)
            var last_x = text.items[0].transform[4]
            var lines = []
            var this_line = ""
            text.items.forEach((vv) => {
              var s = vv.str.trim();
              if(ii == 0) debug('vv-s', s, vv.str)
              if(vv.transform[2] < 0) {
                if(ii == 0) debug('skip text', s)
              }
              else {
                const this_transform = vv.transform.slice(0, 4)
                const this_x = vv.transform[4]
                if(ii == 0) debug('this_transform', isEqual(last_transform, this_transform), this_transform, last_transform, s)
                var new_line = false
                if(!isEqual(last_transform, this_transform))
                  new_line = true
                else if(last_x > this_x)
                  new_line = true
                if(!new_line) {
                    this_line += s
                }
                else {
                  if(ii == 0) debug('pushing new line', this_line)
                  lines.push(this_line)
                  lines.push('\r\n')
                  last_transform = Object.assign([], this_transform)
                  last_x = this_x
                  this_line = s
                }
              }
            });
            if(this_line !== "") lines.push(this_line)
            return lines.join("");
          });
        });
        page_pps.push(pp);
      }
      return Promise.all(page_pps).then((page_contents) => {
        return { numPages: pdf.numPages, pdf_data, page_contents };
      });
    });
  debug('createLoadingTask', p)
  return p;
}

function ab2str(buf) {
  return String.fromCharCode.apply("utf-8", new Uint16Array(buf));
}

var errorHandling = function(fn) {
  return function() {
    return fn.apply(this, arguments).catch((err)=>{
      debug("errorHandling", err, fn, arguments)
      var msg = "";
      if(err && err.no_view_right) {
        msg = i18n.t("err.no_view_right")
      }
      else if (err && err.response) {
        // var codec = new TextDecoder();
        msg = err.config.url + " returned with status code " + err.response.status;
      } else if (err && err.request) {
        msg = err.config.url + " failed when requesting";
      } else if (err) {
        msg = err.message;
      }
      else {
        msg = 'unknown error'
      }
      store.commit("error", msg);
      if(err) throw err;
      else throw new Error(msg);
    })
  }
}

function get_indexed_artis(uniname, opt) {
  const {onDownloadProgress, onDownloadComplete} = opt
  const url = urljoin("/udpes/api/j/", uniname, 'iartis')
  const {access_token} = getTokens()
  const headers = {
    Authorization: "Bearer " + access_token,
  }
  const opt_axios = {onDownloadProgress, headers}

  if(onDownloadProgress) onDownloadProgress({loaded: 0, total: 1})
  return axios.get(url, opt_axios).then((resp) => {
    return resp.data;
  }).finally(()=>{
    if(onDownloadComplete) onDownloadComplete()
  })
}

function get_login_by_user(user_id, pwd) {
  const endpoint = "/udpes/api/auth/user"
  const data = pickBy({user_id, pwd}, i=>i!==undefined)
  debug('data', data)
  return axios.post(endpoint, data).then((resp) => {
    const tokens = {
      access_token: resp.data.access_token,
      refresh_token: resp.data.refresh_token,
    }
    debug('on get_login_by_user()', tokens)
    setTokens(tokens)
    return tokens
  }, (err)=>{
    setTokens({})
    throw err
  })
}

function get_login_by_ip() {
  // console.trace('get_login_by_ip()')
  // debug(getTokens())
  var endpoint = "/udpes/api/auth/ip"
  return axios.post(endpoint).then((resp) => {
    const tokens = {
      access_token: resp.data.access_token,
      refresh_token: resp.data.refresh_token,
    }
    debug('on get_login_by_ip()', tokens)
    setTokens(tokens)
    return tokens
  }, (err)=>{
    setTokens({})
    throw err
  })
}

function refresh_token() {
  debug('refresh_token()')
  const endpoint = "/udpes/api/auth/refresh"
  const {refresh_token} = getTokens()
  return axios.post(endpoint, null, {
    headers: {
      Authorization: "Bearer " + refresh_token,
    },
  }).then((resp) => {
    const tokens = {
      access_token: resp.data.access_token,
      refresh_token: resp.data.refresh_token,
    }
    setTokens(tokens)
    return resp
  }, (err)=>{
    setTokens({})
    throw err
  })
}

function parseMultipart(resp) {
  return new Promise((resolve)=>{
    var pdf_data = undefined, contents = undefined, meta = undefined, images = undefined, hilit_count = undefined
    var bb = new Busboy({ headers: resp.headers })
    .on("file", function(fieldname, file, filename, encoding, mimetype) {
      if (fieldname === "pdf") {
        var dd = new Uint8Array()
        file.on("data", (data) => {
          dd = new Uint8Array([...dd, ...data])
        })
        file.on("end", () => {
          pdf_data = dd
        })
      } else {
        file.resume()
      }
    })
    .on("field", (fieldname, val) => {
      if (fieldname == "meta") {
        meta = JSON.parse(val)
      }
      if (fieldname == "images") {
        images = JSON.parse(val)
      }
      else if (fieldname == "contents") {
        contents = val
      }
      else if (fieldname == "hilit_count") {
        hilit_count = Number(val)
      }
    })
    .on("finish", () => {
      const bbResult = pickBy({contents, meta, images, hilit_count, pdf_data}, i=>i!==undefined)
      resolve(bbResult)
    })
    const dd = new Uint8Array(resp.data)
    bb.end(dd)
  })
}

function hilit_article(meta_no, q) {
  const endpoint = urljoin('/udpes/api/aa', meta_no, 'hilit', q)
  const {access_token} = getTokens()
  const headers = {
    Authorization: "Bearer " + access_token,
  }
  return axios.get(endpoint, {headers}).then((resp) => {
    return resp.data;
  })
}

function view_article(meta_no, options={}) {
  const endpoint = urljoin('/udpes/api/aa', meta_no)
  const responseType = 'arraybuffer'
  const {access_token} = getTokens()
  // debug('view_article::access_token', access_token)
  const headers = {
    Authorization: "Bearer " + access_token,
  }
  const {q, onDownloadProgress, onDownloadComplete} = options
  const params = q ? {q} : {}
  const opt = {
    responseType,
    headers,
    params,
    onDownloadProgress,
  }
  if(onDownloadProgress) onDownloadProgress({loaded: 0, total:1})
  // debug('view_article calling', endpoint)
  return axios.get(endpoint, opt).then((resp) => {
    // debug('ajax resp', resp)
    return parseMultipart(resp).then((bbResult)=>{
      // debug('bbResult', bbResult)
      const {pdf_data} = bbResult
      delete bbResult.pdf_data
      if (pdf_data) {
        return load_pdf(new Uint8Array(pdf_data)).then((rr) => {
          return Object.assign({}, bbResult, rr)
        })
      }
      else {
        return bbResult
      }
    })
  }).catch((err)=>{
    if(err) err.no_view_right = true
    throw err
  }).finally(()=>{
    if(onDownloadComplete) onDownloadComplete()
  })
}

function refreshHandling(fn) {
  return function() {
    const {auth_type} = getIdentity()
    // debug('auth_type', auth_type)
    return fn.apply(this, arguments).catch((err)=>{
      // debug('err on refreshHandling', fn, arguments)
      debug('err on refreshHandling', err)
      if (err && err.response && err.response.status == 401) {
        return refresh_token().then(()=>{
          return fn.apply(this, arguments)
        }, (err) => {
          // debug('2nd err on refreshHandling', fn, arguments)
          debug('2nd err on refreshHandling', err)
          debug('auth_type 2', auth_type)
          if(auth_type == 'ip' && err && err.response && err.response.status == 401) {
            return get_login_by_ip().then(()=>{
              return fn.apply(this, arguments)
            })
          }
          else {
            throw err
          }
        })
      }
      if (!auth_type) {  // access token fail (maybe null ==> auth_type undefined)
        return get_login_by_ip().then(()=>{
          return fn.apply(this, arguments)
        })
      }
      else {
        throw err
      }
    })
  }
}

function check_ip(ip, options={}) {
  const endpoint = urljoin('/udpes/api/admin/chkip', ip)
  const {access_token} = getTokens()
  // debug('access_token', access_token)
  const headers = {
    Authorization: "Bearer " + access_token,
  }
  return axios.post(endpoint, "", { headers }).then((resp) => {
    return resp.data;
  }).finally(()=>{
  })
}

function check_user(user, options={}) {
  const endpoint = urljoin('/udpes/api/admin/chkuser', user)
  const {access_token} = getTokens()
  // debug('access_token', access_token)
  const headers = {
    Authorization: "Bearer " + access_token,
  }
  return axios.post(endpoint, "", { headers }).then((resp) => {
    return resp.data;
  }).finally(()=>{
  })
}


function get_recent_log(options={}) {
  const endpoint = '/udpes/api/admin/recent_log'
  const {access_token} = getTokens()
  const headers = {
    Authorization: "Bearer " + access_token,
  }
  return axios.get(endpoint, { headers }).then((resp) => {
    return resp.data;
  }).finally(()=>{
  })
}

function post_upload_api_(endpoint, formData, options={}) {
  const {access_token} = getTokens()
  const headers = {
    Authorization: "Bearer " + access_token,
  }
  return axios.post(endpoint, formData, { headers }).then((resp) => {
    return resp.data;
  }).finally(()=>{
  })
}

function upload_acl(formData, options={}) {
  const endpoint = '/udpes/api/admin/acl'
  return post_upload_api_(endpoint, formData, options)
}

function upload_jlist(formData, options={}) {
  const endpoint = '/udpes/api/admin/jlist'
  return post_upload_api_(endpoint, formData, options)
}

function upload_userpwd(formData, options={}) {
  const endpoint = '/udpes/api/admin/userpwd'
  return post_upload_api_(endpoint, formData, options)
}

const qq_export = errorHandling(refreshHandling(
  function(q, opts) {
    const {setsn, fields, fromYear, fromMonth, toYear, toMonth, sort} = opts
    const {onDownloadProgress, onDownloadComplete} = opts
    const {access_token} = getTokens()
    const headers = {
      Authorization: "Bearer " + access_token,
    }
    const opt_axios = {headers, responseType: 'blob'}
    const url = '/udpes/api/export/qq'
    const data = {q, setsn, fields, fromYear, fromMonth, toYear, toMonth, sort}
    for(let k in data) {
      if(!data[k]) delete data[k]
    }
    if(onDownloadProgress) onDownloadProgress({loaded: 0, total: 1})
    return axios.post(url, data, opt_axios).then((resp) => {
      return resp.data;
    }).finally(()=>{
      if(onDownloadComplete) onDownloadComplete()
    })
  }
));

const upload_removed = errorHandling(function(formData, options={}) {
  const endpoint = '/udpes/api/admin/removed'
  return post_upload_api_(endpoint, formData, options)
})

const upload_prod_desc = errorHandling(function(formData, options={}) {
  const endpoint = '/udpes/api/admin/prod_desc'
  return post_upload_api_(endpoint, formData, options)
})

const upload_userpwd_ = errorHandling(upload_userpwd)
const upload_jlist_ = errorHandling(upload_jlist)
const get_recent_log_ = errorHandling(get_recent_log)
const upload_acl_ = errorHandling(upload_acl)
const get_journal_ = errorHandling(get_journal)
const get_login_by_ip_ = errorHandling(get_login_by_ip)
const get_login_by_user_ = errorHandling(get_login_by_user)
const refresh_token_ = errorHandling(refresh_token)
const get_journal_vols_ = errorHandling(get_journal_vols)
// const search_j_ = errorHandling(search_journal)
// const search_collection_ = errorHandling(search_collection)
// const search_all_ = errorHandling(search_all)
const generic_api_ = errorHandling(generic_api)

const get_indexed_artis_ = errorHandling(refreshHandling(get_indexed_artis))
const view_article_ = errorHandling(refreshHandling(view_article))
const qq_ = errorHandling(refreshHandling(qq))
const hilit_article_ = errorHandling(hilit_article)

const check_ip_ = errorHandling(refreshHandling(check_ip))
const check_user_ = errorHandling(refreshHandling(check_user))

const all_urights = ['soc', 'sin', 'bio', 'mdn', 'cbs', 'tai', 'syu', 'art', 'waa'].sort()

export {
  upload_prod_desc, upload_removed,
  qq_export,
  upload_userpwd_ as upload_userpwd,
  upload_jlist_ as upload_jlist,
  get_recent_log_ as get_recent_log,
  upload_acl_ as upload_acl,
  all_urights,
  get_toc,
  get_toc_name,
  get_journal_ as get_journal,
  view_article_ as view_article,
  get_login_by_ip_ as get_login_by_ip,
  refresh_token_ as refresh_token,
  get_journal_vols_ as get_journal_vols,
  get_indexed_artis_ as get_indexed_artis,
  get_login_by_user_ as get_login_by_user,
  generic_api_ as generic_api,
  qq_ as qq,
  hilit_article_ as hilit_article,
  check_ip_ as check_ip,
  check_user_ as check_uid,
}

function init_token() {
  const dateTime = Date.now()
  const timestamp = Math.floor(dateTime / 1000)
  var ip_based = false
  // debug('init_token', store.state.access_token, store.state.refresh_token)
  const {access_token, refresh_token} = getTokens()
  debug('tokens', {access_token, refresh_token})
  if(!access_token) {
    return get_login_by_ip_()
  }
  try {
    const decoded = jwt_decode(refresh_token)
    // debug('decoded', decoded)
    // debug('identity', decoded.identity)
    ip_based = Boolean(decoded.identity.auth_type == 'ip')
    if(decoded.exp < timestamp) {
      if(decoded.identity.auth_type == 'ip') {
        return get_login_by_ip_()
      }
      throw (new Error('refresh_token expired'))
    }
  }
  catch(e) {
    debug(e.message)
    setTokens({})
  }
  try {
    const decoded = jwt_decode(access_token)
    if(decoded.exp < timestamp) {
      throw (new Error('access_token expired'))
    }
  }
  catch(e) {
    debug(e.message)
    return refresh_token_().catch((error)=>{
      if(ip_based) {
        return get_login_by_ip_()
      }
      else {
        return Promise.reject(error)
      }
    })
  }
}

init_token()
